(function (angular) {
    'use strict';

    angular
    .module('SMART2')
    .service('publicUtilities', ['$translate', 'APPCONSTANTS', '$timeout', 'PUBLICURLs', 'httpService', '$http', 'notification', '$window', '$filter', publicUtilitiesFunc])

    function publicUtilitiesFunc($translate, APPCONSTANTS, $timeout, PUBLICURLs, httpService, $http, notification, $window, $filter) {
        var moduleScopes = [
            { DocType: 1, name: "rfx", description: Resources["Common.Menu.RFx"] },
            { DocType: 2, name: "rfx", description: Resources["Common.Menu.RFx"] },
            { DocType: 3, name: "rfx", description: Resources["Common.Menu.RFx"] },
            { DocType: 4, name: "auction", description: Resources["Search_Auctions"] },
            { DocType: 5, name: "contract", description: Resources["Search_Contracts"] },
            { DocType: 11, name: "forms", description: Resources["Search_Forms"] },
            { DocType: 12, name: "scorecards", description: Resources["Search_Scorecards"] },
            { DocType: -1, name: "partners", description: Resources["Common.Menu.Partners"] },
            { DocType: 6, name: "catalog", description: Resources["Common.Menu.Catalog"] },
            { DocType: 7, name: "requisition", description: Resources["Common.Menu.Requisition"] },
            { DocType: 8, name: "order", description: Resources["Search_Orders"] },
            { DocType: 9, name: "invoice", description: Resources["Search_Invoices"] },
            { DocType: 10, name: "receipt", description: Resources["Common.Menu.Receipt"] },
            { DocType: 14, name: "invoicereconciliation", description: Resources["Search_InvoiceReconciliations"] },
            { DocType: 16, name: "request", description: Resources["Search_Common_REQUESTS"] },
            { DocType: 17, name: "request", description: Resources["Search_Common_REQUESTS"] },
            { DocType: 18, name: "request", description: Resources["Search_Common_REQUESTS"] },
            { DocType: 27, name: "request", description: Resources["Search_Common_REQUESTS"] },
            { DocType: 21, name: "project", description: Resources["Search_Projects"] },
            { DocType: 22, name: "creditmemo", description: Resources["Search_CreditMemos"] },
            { DocType: 20, name: "returnnote", description: Resources["Search_ReturnNotes"] },
            { DocType: 23, name: "actionplan", description: "Action Plan" },
            { DocType: 30, name: "blanket", description: Resources["Common.Menu.Blanket"] },
            { DocType: 31, name: "serviceconfirmation", description: Resources["Search_ServiceConfirmation"] },
            { DocType: 28, name: "categoryworkbench", description: Resources["Search_CategoryWorkbench"] },
            { DocType: 101, name: "projectdashboard", description: "projectdashboard" },
			{ DocType: 13, name: "p2ptemplates", description: "p2ptemplates" },
            { DocType: 19, name: "partners", description: Resources["Common.Menu.Partners"] }
        ];
        this.search = function (documentType, searchKeyword, advancedQuery, filterInput, bpc, successCB, failureCB) {
            var SearchPanel = {}, objModuleScope = _.filter(moduleScopes, function (obj) { return obj.DocType == documentType }),
                scopeName = objModuleScope && objModuleScope.length ? objModuleScope[0].name : documentType;
            URL = PUBLICURLs.publicRfx;
         
            SearchPanel.CultureCode = 'en-US';
            SearchPanel.AdvanceSearchInput = advancedQuery;
            SearchPanel.Filters = new Array();
            SearchPanel.Filters.push("moduleScope:" + scopeName);
            SearchPanel.Filters.push("isGlobalSearch:false");
            SearchPanel.Filters.push("PageType:Public");           
            SearchPanel.BuyerPartnerCode = bpc;
            SearchPanel.Filters = SearchPanel.Filters.concat(filterInput);
            //angular.extend(SearchPanel.Filters, filterInput);
            return makeServiceCall(URL, null, SearchPanel, successCB, failureCB);
        }
        this.makeServiceCall = makeServiceCall;
        function makeServiceCall(url, method, params, successCB, failureCB) {
            var requestObj = {
                method: method ? method : 'POST',
                url: url
            };
            if (params) {
                requestObj.data = params;
            }
            requestObj['headers'] = { 'IsAnonymous': true };
            var serviceCall = httpService.directhttp(requestObj);
            serviceCall.then(function (data) {
                if (successCB) {
                    successCB(data);
                }
            }).catch(function (errorData) {
                if (failureCB) {
                    failureCB(errorData);
                }
            });
        }
        function unbindWindowOnbeforeunload() {
            $window.onbeforeunload = null;
        };
        function bindWindowOnbeforeunload() {
            $window.onbeforeunload = function (e) {
                var dialogText = 'There are unsaved changes. Do you want to stay?';
                e.returnValue = dialogText;
                return dialogText;
            };
        };
        this.downloadFile = function (attachmentId,filedid) {
            unbindWindowOnbeforeunload();
            var fileDownloadUrl = "";
            if(filedid){
                fileDownloadUrl = PUBLICURLs.fileDownloadUrl + "&AttachmentId=" + attachmentId + "&filedid=" + filedid;
            }else{
                fileDownloadUrl = PUBLICURLs.fileDownloadUrl + "&AttachmentId=" + attachmentId;
            }
            
            var result = "success", url = fileDownloadUrl,
            msie = window.navigator.userAgent.indexOf("MSIE");
            if (msie > 0)      // If Internet Explorer, return version number
                window.open(url);
            else                 // If another browser, return 0
                window.location.href = url;
            setTimeout(function () {
                bindWindowOnbeforeunload()
            }, 20);
            return result;
        }
    }
})(angular);
